import PillGridNew from "components/PillGridNew";

import website_status_data from "libs/website_status_data.json";

const ClientsFilters = ({ values, onChange, t }) => (
  <PillGridNew
    header={t("Status")}
    label={t("Select status")}
    selected={values?.status}
    options={website_status_data.map((item) => ({
      ...item,
      label: t(item.label),
    }))}
    onChange={(option) => onChange("status", option.key)}
  />
);

export default ClientsFilters;